import React, { useMemo } from "react";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryTheme, VictoryTooltip,
} from "victory";

const ModelBookingsPie = ({ rentals }) => {


  const rentalsBookings = useMemo(() => {
    return (rentals || []).map((r) => ({
      ...r,
      numBookings: (r?.bookings || []).length
    }))
  }, [rentals])

  return (
    <div className="w-100 h-100 position-relative">
      <h5 className="position-absolute text-center w-100" style={{ top: 0 }}>
        Numero de reservas por vespa
      </h5>
      <VictoryChart
        theme={VictoryTheme.material}
        domainPadding={20}
      >
        <VictoryAxis label={"Vespas"} tickFormat={() => ""} />
        <VictoryAxis dependentAxis/>
        <VictoryBar
          theme={VictoryTheme.material}
          barRatio={0.8}
          labelComponent={<VictoryTooltip/>}
          data={rentalsBookings}
          x={"licensePlate"}
          y={"numBookings"}
          labels={rentalsBookings.map(({ licensePlate }) => licensePlate)}
        />
      </VictoryChart>
    </div>

  )

}

export default ModelBookingsPie